declare function require(moduleName: any): any;

export const environment = {
  recaptchaV2InvisibleSiteKey: '6LeN_U0rAAAAAN2_YwMwj4_Kci9qOiRQvED53euQ',
  amplitude: '78eff6d67bbb6691d20a56a050ec2916',
  typeForm: 'CzfYt6Mh',
  production: true,
  env: 'prod',
  apiUrlMock: 'http://localhost:3000',
  apiUrl: 'https://api.marsaude.net/v1',
  loginRedirect: 'https://painel.marsaude.net',
  appUser: 'https://app.marsaude.net',
  version: require('../../package.json').version,
  build: require('../../package.json').build,
  presharedKey: 'DK8GyrYYs/cqjZ6s6yl8L44BKPDbD/l/dhLCJxUyqoKkjsm2TkyXLuThmj5bdUZKZd5m4Rc/rop7rSY1uvPDDw==',
  company: {
    name: 'Mar Saúde',
  },
};
